'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/arrow/ArrowBackIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var ArrowBackIcon = (props) => /* @__PURE__ */ jsxs(
  "svg",
  __spreadProps(__spreadValues({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.66634 4.66663V7.72382L10.9425 9.99996L9.99967 10.9428L7.33301 8.2761V4.66663H8.66634Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.66634 2.66663V5.33329H5.33301V6.66663H1.33301V2.66663H2.66634Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.99955 2.66671C5.79072 2.66671 3.89401 4.00962 3.08426 5.92617L2.82479 6.54027L1.59659 6.02135L1.85605 5.40725C2.86698 3.01454 5.23617 1.33337 7.99955 1.33337C11.6814 1.33337 14.6662 4.31814 14.6662 8.00004C14.6662 11.6819 11.6814 14.6667 7.99955 14.6667C5.0958 14.6667 2.62727 12.8106 1.7124 10.2222L1.49023 9.59365L2.74735 9.14932L2.96952 9.77788C3.70199 11.8502 5.67842 13.3334 7.99955 13.3334C10.9451 13.3334 13.3329 10.9456 13.3329 8.00004C13.3329 5.05452 10.9451 2.66671 7.99955 2.66671Z",
          fill: "currentColor"
        }
      )
    ]
  })
);

// src/arrow/ArrowIcon.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var ArrowIcon = (props) => {
  return /* @__PURE__ */ jsx2(
    "svg",
    __spreadProps(__spreadValues({
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx2(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.13807 3.52876C7.39842 3.78911 7.39842 4.21122 7.13807 4.47157L4.27615 7.33348H13.3333C13.7015 7.33348 14 7.63196 14 8.00015C14 8.36834 13.7015 8.66682 13.3333 8.66682H4.27614L7.13807 11.5288C7.39842 11.7891 7.39842 12.2112 7.13807 12.4716C6.87772 12.7319 6.45561 12.7319 6.19526 12.4716L2.19526 8.47155C2.07024 8.34653 2 8.17696 2 8.00015C2 7.82334 2.07024 7.65377 2.19526 7.52875L6.19526 3.52876C6.45561 3.26841 6.87772 3.26841 7.13807 3.52876Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/arrow/ArrowRotateIcon.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var ArrowRotateIcon = (props) => /* @__PURE__ */ jsx3(
  "svg",
  __spreadProps(__spreadValues({
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx3(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 6C0 9.31371 2.68629 12 6 12C7.68461 12 9.23712 11.3051 10.3412 10.1845V11.5C10.3412 11.7761 10.5651 12 10.8412 12C11.1174 12 11.3412 11.7761 11.3412 11.5V8.83333C11.3412 8.55719 11.1174 8.33333 10.8412 8.33333L8.17456 8.33333C7.89842 8.33333 7.67456 8.55719 7.67456 8.83333C7.67456 9.10948 7.89842 9.33333 8.17456 9.33333L9.77013 9.33333C8.84293 10.3555 7.48259 11 6 11C3.23858 11 1 8.76142 1 6C1 5.7879 1.01318 5.57912 1.03871 5.37437C1.07288 5.10035 0.878442 4.85051 0.604422 4.81634C0.330402 4.78217 0.0805644 4.97661 0.0463946 5.25063C0.0157568 5.49633 0 5.74644 0 6ZM11.3956 7.18366C11.6696 7.21783 11.9194 7.02339 11.9536 6.74937C11.9842 6.50367 12 6.25356 12 6C12 2.68629 9.31371 0 6 0C4.3194 0 2.77027 0.691617 1.66667 1.80748V0.5C1.66667 0.223858 1.44281 0 1.16667 0C0.890524 0 0.666667 0.223858 0.666667 0.5L0.666667 3.16667C0.666667 3.44281 0.890524 3.66667 1.16667 3.66667H3.83333C4.10948 3.66667 4.33333 3.44281 4.33333 3.16667C4.33333 2.89052 4.10948 2.66667 3.83333 2.66667H2.22987C3.15708 1.64454 4.51742 1 6 1C8.76142 1 11 3.23858 11 6C11 6.2121 10.9868 6.42088 10.9613 6.62563C10.9271 6.89965 11.1216 7.14949 11.3956 7.18366Z",
        fill: "currentColor"
      }
    )
  })
);

// src/arrow/ArrowUpDownIcon.tsx
import { jsx as jsx4, jsxs as jsxs2 } from "react/jsx-runtime";
var ArrowUpDownIcon = (props) => {
  return /* @__PURE__ */ jsxs2(
    "svg",
    __spreadProps(__spreadValues({
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [
        /* @__PURE__ */ jsx4(
          "rect",
          {
            width: "1.33333",
            height: "8",
            rx: "0.666667",
            transform: "matrix(1 0 0 -1 4.6665 11.3333)",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx4("rect", { x: "9.3335", y: "4.66675", width: "1.33333", height: "8", rx: "0.666667", fill: "currentColor" }),
        /* @__PURE__ */ jsx4(
          "path",
          {
            d: "M2.81291 7.16256C2.62694 7.39037 2.32544 7.39037 2.13947 7.16256C1.95351 6.93475 1.95351 6.56541 2.13947 6.3376L4.99661 2.8376C5.17689 2.61677 5.46717 2.60904 5.65511 2.82008L8.51225 6.02841C8.70611 6.2461 8.71921 6.6151 8.5415 6.85259C8.36379 7.09007 8.06257 7.10612 7.8687 6.88842L5.34765 4.0575L2.81291 7.16256Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx4(
          "path",
          {
            d: "M7.47941 8.83744C7.29345 8.60963 6.99194 8.60963 6.80598 8.83744C6.62001 9.06525 6.62001 9.43459 6.80598 9.6624L9.66312 13.1624C9.84339 13.3832 10.1337 13.391 10.3216 13.1799L13.1788 9.97159C13.3726 9.7539 13.3857 9.3849 13.208 9.14741C13.0303 8.90993 12.7291 8.89388 12.5352 9.11158L10.0142 11.9425L7.47941 8.83744Z",
            fill: "currentColor"
          }
        )
      ]
    })
  );
};

// src/arrow/DoubleArrowIcon.tsx
import { jsx as jsx5 } from "react/jsx-runtime";
var DoubleArrowIcon = (props) => {
  return /* @__PURE__ */ jsx5(
    "svg",
    __spreadProps(__spreadValues({
      width: "10",
      height: "13",
      viewBox: "0 0 10 13",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx5(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.66679 12.3452L5.00013 9.01187L8.33346 12.3452L9.51197 11.1667L5.00013 6.65484L0.488281 11.1667L1.66679 12.3452ZM1.66679 6.51187L5.00013 3.17853L8.33346 6.51187L9.51197 5.33335L5.00013 0.821511L0.488281 5.33336L1.66679 6.51187Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/arrow/MultipleArrowsIcon.tsx
import { jsx as jsx6 } from "react/jsx-runtime";
var MultipleArrowsIcon = (props) => /* @__PURE__ */ jsx6(
  "svg",
  __spreadProps(__spreadValues({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx6(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.6053 0.693053C10.7749 0.475079 11.089 0.435812 11.307 0.605347L13.9802 2.68455C14.4 3.01106 14.4107 3.64194 14.0022 3.98246L11.3201 6.21808C11.108 6.39489 10.7927 6.36626 10.6159 6.15415C10.4391 5.94203 10.4677 5.62675 10.6799 5.44994L12.6196 3.83303H1C0.723858 3.83303 0.5 3.60917 0.5 3.33303C0.5 3.05689 0.723858 2.83303 1 2.83303H12.5423L10.693 1.3947C10.4751 1.22516 10.4358 0.911026 10.6053 0.693053ZM13.2029 3.34684L13 3.51598V3.18901L13.2029 3.34684ZM0.5 11.333C0.5 11.0569 0.723858 10.833 1 10.833H12.5423L10.693 9.3947C10.4751 9.22516 10.4358 8.91103 10.6053 8.69305C10.7749 8.47508 11.089 8.43581 11.307 8.60535L13.9802 10.6846C14.4 11.0111 14.4107 11.6419 14.0022 11.9825L11.3201 14.2181C11.108 14.3949 10.7927 14.3663 10.6159 14.1541C10.4391 13.942 10.4677 13.6267 10.6799 13.4499L12.6196 11.833H1C0.723858 11.833 0.5 11.6092 0.5 11.333ZM13 11.516L13.2029 11.3468L13 11.189V11.516ZM1 6.8331C0.723858 6.8331 0.5 7.05696 0.5 7.3331C0.5 7.60924 0.723858 7.8331 1 7.8331H9C9.27614 7.8331 9.5 7.60924 9.5 7.3331C9.5 7.05696 9.27614 6.8331 9 6.8331H1Z",
        fill: "currentColor"
      }
    )
  })
);

// src/arrow/ShareArrow.tsx
import { jsx as jsx7 } from "react/jsx-runtime";
var ShareArrow = (props) => {
  return /* @__PURE__ */ jsx7(
    "svg",
    __spreadProps(__spreadValues({
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx7(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.99992 1.47763L19.5876 10L9.99992 18.5224V13.7564C7.0087 13.8037 5.40842 14.1129 4.4351 14.5995C3.45204 15.0911 3.03341 15.7964 2.41194 17.0393L0.833252 16.6667C0.833252 13.0964 1.34529 10.4107 2.98376 8.6509C4.50723 7.01458 6.83369 6.35582 9.99992 6.26195V1.47763ZM11.6666 5.18904V7.91667H10.8333C7.34446 7.91667 5.36193 8.54245 4.20358 9.7866C3.39294 10.6573 2.88953 11.9308 2.65555 13.7922C2.94868 13.5396 3.28784 13.3098 3.68974 13.1088C5.12968 12.3888 7.28428 12.0833 10.8333 12.0833H11.6666V14.811L17.0789 10L11.6666 5.18904Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/arrow/UpRightIcon.tsx
import { jsx as jsx8 } from "react/jsx-runtime";
var UpRightIcon = (props) => {
  return /* @__PURE__ */ jsx8(ArrowIcon, { className: `rotate-[135deg] rtl:rotate-45 ${props.className}` });
};

export {
  ArrowBackIcon,
  ArrowIcon,
  ArrowRotateIcon,
  ArrowUpDownIcon,
  DoubleArrowIcon,
  MultipleArrowsIcon,
  ShareArrow,
  UpRightIcon
};
//# sourceMappingURL=chunk-WGPUICHM.mjs.map